import React from 'react'

function Err404() {
    return (
        <div>
            <div className='w3-container w3-white'>
            No such page exsist. Your are in wrong page
            </div>

        </div>
    )
}

export default Err404
